import moment from "moment";
import { IMessageChain } from "Services/API/API";

export const getDefaultImageText = function (name?: string | undefined) {
   if (name) {
      return name[0];
   }
   return "";
}
export const getFormatedTime = function (date: moment.Moment | string | undefined) {
   if (date) {
      date = moment(date);
      if (date.isAfter(moment().subtract(1, "minute"))) {
         return "Just Now"
      }
      else {
         return date.format("H:mm A");
      }
   }
   else {
      return "";
   }
};
export const getFormatedDate = function (date: moment.Moment | string | undefined) {
   if (date) {
      date = moment(date);
      if (date.isAfter(moment().subtract(1, "minute"))) {
         return "Just Now"
      }
      else if (date.isSame(new Date(), "day")) {
         return date.format("H:mm A");
      }
      else {
         return date.format("MMM D, yyyy H:mm A");
      }
   }
   else {
      return "";
   }
};

const internalHostnameRegex = /^(\w+\.)*(liquidspace|liquidspaceapp)\.com$/i;

export function formatMessage(chainMessageRules: { [key: string]: string; }, message: string, configureAnchor?: (a: HTMLAnchorElement) => void): { html: string, hasExternalLinks: boolean } {
   function escapeRegexp(text) {
      return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
   }
   let hasExternalLinks = false;
   let fixedMessage = (message ?? "")
      .replace(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g, substring => {
         const url = new URL(substring);
         const isInternal = url.hostname.match(internalHostnameRegex) != null;
         const anchorElement = document.createElement("a");

         anchorElement.classList.add("messenger-message-link");

         if (isInternal) {
            anchorElement.classList.add("messenger-message-link--internal");
         }
         else {
            hasExternalLinks = true;
            anchorElement.classList.add("messenger-message-link--external");
            anchorElement.title = "Link may be unsafe or potentially malicious. Proceed with caution — do not click on the link unless you trust the sender and are certain the URL is safe.";
         }

         anchorElement.href = url.toString();
         anchorElement.target = "_blank";

         anchorElement.innerText = url.toString();

         configureAnchor && configureAnchor(anchorElement);

         return anchorElement.outerHTML;
      })
      .replace(/<br.*?>/g, "\n");
   const messageRules = [];
   for (const messageRule in chainMessageRules) {
      if (chainMessageRules.hasOwnProperty(messageRule)) {
         const key = messageRule.toLowerCase();
         messageRules[key] = chainMessageRules[messageRule];
      }
   }
   const keys = Object.keys(messageRules).sort(function (a, b) {
      return a.length - b.length;
   });
   if (keys.length) {
      for (let i = 0; i < keys.length; i++) {
         keys[i] = escapeRegexp(keys[i]);
      }
      fixedMessage = fixedMessage.replace(new RegExp(keys.join("|"), "gi"), function (matched) {
         return messageRules[matched.toLowerCase()];
      });
   }
   return { html: fixedMessage, hasExternalLinks };
}
